import type { Review } from "@/data/reviewTypes";

export const ELPASO_REVIEWS: Review[] = [
  { name: "Miguel K.", initials: "MK", rating: 5, date: "1 week ago", text: "ELP curbside pickup for a 14-person crew to Sun Bowl. Sprinter was spotless, driver knew every El Paso shortcut. Booking again." },
  { name: "Sara R.", initials: "SR", rating: 5, date: "3 weeks ago", text: "Bachelorette weekend around Downtown El Paso. Easy delivery to our hotel, captain's chairs, cold AC even in El Paso heat. Perfect." },
  { name: "Devon T.", initials: "DT", rating: 5, date: "1 month ago", text: "Booked the 15-passenger for El Paso game day. On-time, full tank, no surprise charges. Best van rental in West Texas." },
];
